import { Button, Grid, styled } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import useTranslate from '../../../../../i18n/useTranslate'
import ItemExternalProject from './ItemExternalProject'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import useRouter from '../../../../../router/useRouter'
import { RoutePath } from '../../../../../router/routesConfig'
import { ResultSearchType } from '../../../../../services/manageExternalProject/searchFormExternalProjectType'
import { FC } from 'react'

const TitleResult = styled(Grid)({
    margin: '18px 0px',
})

interface ResultPropsExternal {
    data: ResultSearchType[]
    allData: number
    getList: (projectID?: number) => void
}

const ResultExternalProject: FC<ResultPropsExternal> = ({ data, allData, getList }) => {
    const translate = useTranslate()
    const router = useRouter()

    const handleRoute = () => router.goTo(RoutePath.manageExternalProjectFormAdd)

    return (
        <Grid item xs={12}>
            <TitleResult container justify="space-between" alignItems="center">
                <Typography variant="h5">{translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${allData}`])}</Typography>
                <Button
                    size="large"
                    variant="outlined"
                    color="primary"
                    onClick={handleRoute}
                    startIcon={<AddOutlinedIcon />}
                >
                    <Typography variant="button">{translate.get('LABEL.ADD_PROJECT')}</Typography>
                </Button>
            </TitleResult>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                {data.map((item) => (
                    <ItemExternalProject key={item.projectID} dataItem={item} getList={getList} />
                ))}
            </Grid>
        </Grid>
    )
}

export default ResultExternalProject
